import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';

import jwtStore from 'shared/helpers/jwtStore';
import {
  userDidLogin,
  userWillLogout,
} from 'shared/actions/session';


// Under top level key 'session'.
const initialState = fromJS({
  jwt: (jwtStore.get() || null),
});


export default handleActions({
  [userDidLogin]: (state, action) => {
    const { jwt = null } = action.payload;
    jwtStore.set(jwt);
    return state.updateIn(['jwt'], val => jwt);
  },

  [userWillLogout]: (state, action) => {
    jwtStore.remove();
    return state.updateIn(['jwt'], val => null);
  },
}, initialState);



// WEBPACK FOOTER //
// ./src/shared/reducers/session.js